export default {
    data() {
        return {
            aletrTimer:'',
			
        }
    },
    // 时间转化
    dateConversion (date,type) {
        console.log(date);
        let year = date.getFullYear();
        
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        let hour = date.getHours();
        hour = hour < 10 ? '0' + hour : hour;
        let minute = date.getMinutes();
        minute = minute < 10 ? '0' + minute : minute;
        if(type == 0){//年月日
            return year + '-' + month + '-' + day;
        }else if(type == 1){//年月日时分
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':00';
        }
        
    },
    alertText (text,width,time) {
        $(".alertText").remove();
        clearTimeout(this.aletrTimer);
        let html = '<div class="alertText ac" style="width:'+width+'px;"><div class="in">'+text+'</div></div>';
        $("body").append(html);
        if(time == undefined){
            time = 2000;
        }
        this.aletrTimer = setTimeout(() => {
            $(".alertText").remove();
        }, time);
    },
    //计算时间跨度
    getDateDiff(startDate,endDate){  
        let startTime = new Date(Date.parse(startDate.replace(/-/g,   "/"))).getTime();     
        let endTime = new Date(Date.parse(endDate.replace(/-/g,   "/"))).getTime();     
        let dates = Math.abs((startTime - endTime))/(1000*60*60*24);     
        return  dates;    
    },
    // 检测数组位置
    indexOf(arr, str){
        // 如果可以的话，调用原生方法
        if(arr && arr.indexOf){
            return arr.indexOf(str);
        }
         
        let len = arr.length;
        for(let i = 0; i < len; i++){
            // 定位该元素位置
            if(arr[i] == str){
                return i;
            }
        }
         
        // 数组中不存在该元素
        return -1;
    },
    // 获取当前时间
    getNowDate(type) {//获取当前时间
        let date = new Date();
        let seperator1 = "-";
        let seperator2 = ":";
        let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
        let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
        let currentdate = '';
        if(type === 0){//不带时分秒
            currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
        }else{//带时分秒
            currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
            + " "  + date.getHours()  + seperator2  + date.getMinutes()
            + seperator2 + date.getSeconds();
        }
        return currentdate;
    },
    // 获取当前时间前的时间 天数自定义
    getBeforeDay(date,num){
        var date = date || new Date(),
            timestamp, 
            newDate;
        if(!(date instanceof Date)){
            date = new Date(date.replace(/-/g, '/'));
        }
        timestamp = date.getTime();
        newDate = new Date(timestamp - num * 24 * 3600 * 1000);
        let month = newDate.getMonth() + 1;
        month = month.toString().length == 1 ? '0' + month : month; 
        let day = newDate.getDate().toString().length == 1 ? '0' + newDate.getDate() :newDate.getDate();
        return [newDate.getFullYear(), month, day].join('-');
    },
    // 判断数组是否包含
    isIncludes(parentArr, childrenArr) {
        let tempArrLength = Array.from(new Set([...parentArr, ...childrenArr])).length
        return tempArrLength === parentArr.length
    },
    
}


// WEBPACK FOOTER //
// ./src/utils/index.js